import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentCardModel, PaymentCardTypes } from '../paymentcard.model';
import { PaymentCardService } from '../paymentcard.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PaymentCardDialogDeleteComponent } from '../paymentcard-dialog-delete.component';
import { BankAccountModel } from '../../bancos/bankaccount.model';
import { BankAccountService } from '../../bancos/bankaccount.service';
import { DummyComponent } from '../../../../shared/dummy.component';
import { PaymentCardComponent } from '../paymentcard.component';
import { PaymentCardDialogMovimientoTarjetaCreditoComponent } from './paymentcard-dialog-movimiento-tarjeta-credito.component';
import { TarjetaCreditoConst } from '../const';
import { TableService } from '../../../../shared/components/table/table.service';
import { consts } from '../../../../consts';
import { Utils } from '../../../../shared/utils';
import { AccountingAccountsModel } from '../../../accounting/accounting-accounts/accounting-accounts.model';
import { AccountingAccountsService } from '../../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsDialogLedgerComponent } from '../../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';

@Component({
    selector: 'convfact-paymentcard-list',
    templateUrl: './paymentcard-list.component.html',
    styleUrls: ['../paymentcard.component.css'],
    standalone: false
})
export class PaymentCardListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public dataSource: PaymentCardModel[] = [];
  public bankAccounts: BankAccountModel[] = [];
  public empty = false;
  public ready = false;
  public headerTable: any[] = TarjetaCreditoConst.headerTable;

  constructor(
    private router: Router,
    private paymentCardService: PaymentCardService,
    public dialog: MatDialog,
    private bankAccountService: BankAccountService,
    public dummy: DummyComponent,
    private tableService: TableService,
    public snackBar: MatSnackBar,
    private accountingAccountsService: AccountingAccountsService,
  ) { }

  public create(uid: string = undefined): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    uid = null;
    this.dialog.open(PaymentCardComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Credito }
    })
      .afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PaymentCardDialogDeleteComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Credito }
    })
      .afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PaymentCardComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Credito }
    })
      .afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public movimientotarjetacredito(uid: string, tipoMovimientoTarjetaCreditoId: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const paymentCardSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PaymentCardDialogMovimientoTarjetaCreditoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { paymentCard: paymentCardSelected, tipoMovimientoTarjetaCreditoId: tipoMovimientoTarjetaCreditoId }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  ngOnInit() {
    this.getList();
  }

  public getList() {
    this.paymentCardService.getList(PaymentCardTypes.Tarjeta_Credito, this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.bankAccountService.getList().then(response => {
          this.bankAccounts = response.list;
          this.dataSource.forEach(paymentCard => {
            this.bankAccounts.forEach(bankAccount => {
              if (paymentCard.bankAccountUid === bankAccount.uid) {
                paymentCard.bank = bankAccount.bank;
                paymentCard.iban = bankAccount.iban;
              }
            });
          });
        });
        this.ready = true;
      }
    );
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public mayor(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel =
      new AccountingAccountsModel();

    this.accountingAccountsService
      .list(0, 1, searchedElement.accountNumber)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
          accountingModels = accountingModelsResponse[0];
        }

        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number,
          },
        });
      });
  }

}
